import { render, staticRenderFns } from "./ProviderShowSocial.vue?vue&type=template&id=48dd87f1"
import script from "./ProviderShowSocial.vue?vue&type=script&lang=js"
export * from "./ProviderShowSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports